<template>
  <v-app>

    <v-main class="background">

      <div class="gemeinschaftsverpflegung-page">

        <!-- =====================================================
             HAUPT-CONTENT
        ====================================================== -->
        <div class="content-container">

          <!-- =================================================
               HAUPTÜBERSCHRIFT
          ================================================== -->
          <div class="hero-content">

            <h1 class="page-title">
              Gemeinschafts<wbr>verpflegung
            </h1>

            <div class="heading-line"></div>

            <p class="hero-subtitle">
              Sichere Lösungen für eine verantwortungsvolle<br>
              und hygienische Verpflegung.
            </p>

          </div>


          <!-- =================================================
               ZITATBOX
          ================================================== -->
          <div class="quote-box">

            <span class="quote quote-left">“</span>

            <div class="quote-content">

              <div class="quote-title">
                Probleme gibt es genug.
              </div>

              <div class="quote-text">
                Uns geht es darum, Lösungen zu finden,
                die im Alltag funktionieren.
              </div>

              <div class="quote-line"></div>

            </div>

            <span class="quote quote-right">”</span>

          </div>


          <!-- =================================================
               HAUPTTEXT
          ================================================== -->
          <div class="content-text">

            <p>
              Wir begleiten Einrichtungen der Gemeinschaftsverpflegung dabei,
              mit Hygiene sicher umzugehen. Nicht theoretisch und nicht mit
              erhobenem Zeigefinger, sondern so, dass es im täglichen Betrieb
              umsetzbar bleibt.
            </p>

            <p>
              Gerade in Küchen, in denen viele Menschen versorgt werden,
              entsteht schnell Unsicherheit. Abläufe greifen ineinander,
              Verantwortung ist verteilt und Anforderungen kommen oft
              zusätzlich zum normalen Arbeitsalltag dazu.
            </p>

            <p>
              Viele arbeiten sauber und gewissenhaft
              und haben trotzdem ein ungutes Gefühl,
              wenn Kontrollen anstehen oder Entscheidungen getroffen werden müssen.
            </p>

            <p>
              Das hat meist wenig mit mangelnder Sorgfalt zu tun,
              sondern eher mit fehlender Klarheit im System.
            </p>


            <!-- =================================================
                 ZWISCHENÜBERSCHRIFT
            ================================================== -->
            <p class="highlight-text">
              <strong>Genau dort setzen wir an.</strong>
            </p>

            <div class="small-line"></div>


            <p>
              Wir bringen Struktur in Abläufe, schaffen Verständlichkeit
              und helfen dabei, Hygiene so umzusetzen,
              dass sie im Alltag trägt und nicht zusätzlich belastet.
            </p>

            <p>
              Unsere Arbeit basiert auf vielen Jahren Praxis in der
              Gemeinschaftsverpflegung und über 15 Jahren intensiver Arbeit
              im Thema Hygiene. Nicht aus dem Lehrbuch, sondern aus dem
              täglichen Betrieb.
            </p>

            <p>
              Wir gehen davon aus, dass sich Unsicherheiten klären lassen,
              wenn man sie offen anspricht und gemeinsam Lösungen entwickelt,
              die wirklich passen.
            </p>

            <p>
              Was es dafür braucht, ist die Bereitschaft, Dinge anzuschauen
              und sinnvoll zu verändern. Alles Weitere ergibt sich im
              gemeinsamen Arbeiten.
            </p>

          </div>

        </div>

      </div>

    </v-main>

  </v-app>
</template>


<script setup>
</script>


<style scoped>

/* ============================================================
   GRUNDLAYOUT
============================================================ */

.background {
  padding: 0 !important;
  margin: 0 !important;
}

.gemeinschaftsverpflegung-page {
  position: relative;

  width: 100%;

  min-height: 100vh;

  box-sizing: border-box;

  overflow: hidden;

  color: #111111;

  /*
   * TEXTFREIES HINTERGRUNDBILD
   */
  background-image: url('@/assets/GemPflege.png');

  background-repeat: no-repeat;

  background-position: center top;

  /*
   * Das Bild soll die komplette Breite ausfüllen.
   */
  background-size: cover;
}


/* ============================================================
   HAUPT-CONTAINER
============================================================ */

.content-container {
  position: relative;

  width: 100%;

  max-width: 1000px;

  min-height: 100vh;

  margin: 0 auto;

  box-sizing: border-box;
}


/* ============================================================
   HERO / ÜBERSCHRIFT
============================================================ */

.hero-content {
  position: relative;

  width: 500px;

  padding-top: 27px;

  margin-left: 0;
}


.page-title {
  margin: 0;

  padding: 0;

  color: #17191d;

  font-size: 47px;

  line-height: 1.03;

  font-weight: 700;

  letter-spacing: -1.8px;
}


/* ============================================================
   GRÜNE LINIE UNTER DER ÜBERSCHRIFT
============================================================ */

.heading-line {
  width: 46px;

  height: 3px;

  margin-top: 14px;

  margin-bottom: 13px;

  background: #72b82a;
}


/* ============================================================
   HERO UNTERTITEL
============================================================ */

.hero-subtitle {
  margin: 0;

  padding: 0;

  color: #17191d;

  font-size: 14px;

  line-height: 1.45;

  font-weight: 500;
}


/* ============================================================
   ZITATBOX
============================================================ */

.quote-box {
  position: relative;

  width: 790px;

  min-height: 84px;

  margin-top: 42px;

  margin-left: auto;

  margin-right: auto;

  display: flex;

  align-items: center;

  justify-content: center;

  box-sizing: border-box;

  padding: 10px 70px;

  background: rgba(246, 251, 239, 0.92);

  border: 1px solid rgba(114, 184, 42, 0.15);

  border-radius: 11px;
}


/* ============================================================
   ZITATZEICHEN
============================================================ */

.quote {
  position: absolute;

  color: #72b82a;

  font-family: Georgia, "Times New Roman", serif;

  font-size: 62px;

  line-height: 1;

  font-weight: 700;

  opacity: 0.95;
}


.quote-left {
  left: 25px;

  top: 11px;
}


.quote-right {
  right: 25px;

  bottom: 3px;
}


/* ============================================================
   ZITAT-INHALT
============================================================ */

.quote-content {
  text-align: center;

  width: 100%;
}


.quote-title {
  color: #17191d;

  font-size: 20px;

  line-height: 1.2;

  font-weight: 700;
}


.quote-text {
  margin-top: 4px;

  color: #17191d;

  font-size: 18px;

  line-height: 1.25;

  font-weight: 700;
}


.quote-line {
  width: 38px;

  height: 3px;

  margin: 8px auto 0;

  background: #72b82a;
}


/* ============================================================
   TEXTBEREICH
============================================================ */

.content-text {
  width: 700px;

  margin-top: 20px;

  margin-left: auto;

  margin-right: 0;

  color: #111111;

  font-size: 13px;

  line-height: 1.42;
}


/* ============================================================
   ABSÄTZE
============================================================ */

.content-text p {
  margin: 0 0 11px 0;

  padding: 0;

  color: #111111;

  font-size: 13px;

  line-height: 1.42;

  font-weight: 400;
}


/* ============================================================
   HERVORHEBUNG
============================================================ */

.content-text .highlight-text {
  margin-top: 23px;

  margin-bottom: 0;

  color: #17191d;

  font-size: 18px;

  line-height: 1.2;

  font-weight: 700;
}


.content-text strong {
  color: #17191d;

  font-weight: 700;
}


/* ============================================================
   KLEINE GRÜNE LINIE
============================================================ */

.small-line {
  width: 31px;

  height: 2px;

  margin-top: 8px;

  margin-bottom: 13px;

  background: #72b82a;
}


/* ============================================================
   DESKTOP – GROSSE BILDSCHIRME
============================================================ */

@media (min-width: 1400px) {

  .content-container {
    max-width: 1100px;
  }


  .hero-content {
    padding-top: 28px;
  }


  .page-title {
    font-size: 50px;
  }


  .quote-box {
    width: 800px;

    margin-top: 43px;
  }


  .content-text {
    width: 720px;

    margin-top: 20px;
  }

}


/* ============================================================
   TABLET / KLEINER DESKTOP
============================================================ */

@media (max-width: 1100px) {

  .gemeinschaftsverpflegung-page {
    background-size: auto 100%;

    background-position: center top;
  }


  .content-container {
    width: calc(100% - 50px);

    max-width: 900px;
  }


  .hero-content {
    width: 430px;

    padding-top: 30px;
  }


  .page-title {
    font-size: 40px;
  }


  .quote-box {
    width: 78%;

    margin-top: 35px;
  }


  .quote-title {
    font-size: 18px;
  }


  .quote-text {
    font-size: 16px;
  }


  .content-text {
    width: 67%;

    margin-top: 18px;

    font-size: 12px;
  }


  .content-text p {
    font-size: 12px;

    line-height: 1.4;
  }

}


/* ============================================================
   MOBILE
============================================================ */

@media (max-width: 760px) {

  .gemeinschaftsverpflegung-page {
    min-height: 100vh;

    overflow: visible;

    /*
     * Auf Mobilgeräten wird das Bild nicht verzerrt.
     */
    background-size: auto 100%;

    background-position: center top;

    background-attachment: scroll;
  }


  .content-container {
    width: calc(100% - 30px);

    max-width: none;

    min-height: 100vh;

    margin: 0 auto;
  }


  /* ----------------------------------------------------------
     HERO
  ---------------------------------------------------------- */

  .hero-content {
    width: 100%;

    padding-top: 25px;

    padding-left: 10px;
  }


  .page-title {
    max-width: 350px;

    font-size: 34px;

    line-height: 1.04;

    letter-spacing: -1px;
  }


  .heading-line {
    width: 35px;

    height: 2px;

    margin-top: 11px;

    margin-bottom: 11px;
  }


  .hero-subtitle {
    max-width: 330px;

    font-size: 12px;

    line-height: 1.4;
  }


  /* ----------------------------------------------------------
     ZITAT
  ---------------------------------------------------------- */

  .quote-box {
    width: 100%;

    min-height: 75px;

    margin-top: 30px;

    padding: 10px 42px;
  }


  .quote {
    font-size: 48px;
  }


  .quote-left {
    left: 12px;

    top: 12px;
  }


  .quote-right {
    right: 12px;

    bottom: 0;
  }


  .quote-title {
    font-size: 15px;
  }


  .quote-text {
    font-size: 13px;

    line-height: 1.25;
  }


  .quote-line {
    width: 30px;

    height: 2px;

    margin-top: 6px;
  }


  /* ----------------------------------------------------------
     TEXT
  ---------------------------------------------------------- */

  .content-text {
    width: calc(100% - 20px);

    margin-top: 18px;

    margin-left: auto;

    margin-right: auto;

    font-size: 11.5px;

    line-height: 1.45;
  }


  .content-text p {
    margin-bottom: 12px;

    font-size: 11.5px;

    line-height: 1.45;
  }


  .content-text .highlight-text {
    margin-top: 20px;

    margin-bottom: 0;

    font-size: 16px;
  }


  .small-line {
    width: 28px;

    height: 2px;

    margin-top: 7px;

    margin-bottom: 11px;
  }

}


/* ============================================================
   KLEINE SMARTPHONES
============================================================ */

@media (max-width: 480px) {

  .content-container {
    width: calc(100% - 20px);
  }


  .hero-content {
    padding-top: 20px;

    padding-left: 6px;
  }


  .page-title {
    font-size: 29px;
  }


  .hero-subtitle {
    font-size: 11px;
  }


  .quote-box {
    margin-top: 25px;

    min-height: 68px;

    padding-left: 34px;

    padding-right: 34px;
  }


  .quote {
    font-size: 42px;
  }


  .quote-title {
    font-size: 13px;
  }


  .quote-text {
    font-size: 11.5px;
  }


  .content-text {
    width: calc(100% - 10px);

    font-size: 10.5px;
  }


  .content-text p {
    font-size: 10.5px;

    line-height: 1.4;

    margin-bottom: 10px;
  }


  .content-text .highlight-text {
    font-size: 14px;
  }

}

</style>